import { render, staticRenderFns } from "./ProjectFormView.vue?vue&type=template&id=6b61143a&scoped=true&"
import script from "./ProjectFormView.vue?vue&type=script&lang=js&"
export * from "./ProjectFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b61143a",
  null
  
)

export default component.exports